<panel width="500" class="language-editor" *requiredCredential="editLanguageTranslationsCredential" [ngClass]="{ active: active }">
	<h3 (click)="active = !active">
		{{ title }}
		@if (missingVariables > 0) { <span class="missing-variables"> ({{ missingVariables }})</span> }
	</h3>
	<div class="variable-list">
		@for (variable of variables; track variable) {
			<editable-content *editableData="let edit from variable.text" (valueChanged)="saveChanges(variable, $event);">
				<display-content>
					<section>
						<text-group [class.highlight]="variable.text === ''">
							<p [title]="variable.identifier">{{ variable.identifier }} @if (variable.textVariables) { <icon small type="circle-info" [title]="'Available variables: ' + getTextVariables(variable.textVariables)" /> }</p>
							<p [title]="variable.text">{{ variable.text }}</p>
						</text-group>
					</section>
				</display-content>
				<edit-content>
					<custom-input [(value)]="edit.value" [allowMultiLine]="true" [label]="variable.identifier" (keyup.enter)="keepFocus($event);" (keyup.control.enter)="confirmEdit();" />
					@if (variable.textVariables) { <span>Available variables: {{ getTextVariables(variable.textVariables) }}</span> }
				</edit-content>
			</editable-content>
		}
	</div>
</panel>
